import React, { useCallback } from 'react';

import ConfirmLogoutModalView from './ConfirmLogoutModalView';

import { useMytaverse } from '../../../../providers/MytaverseProvider';

import { sendCustomSentryBreadcrumb } from '../../../../helpers/sentry';

import { IConfirmLogoutModal } from './interfaces';
import { AnalyticsType } from '../../../../interfaces/analytics';

const ConfirmLogoutModal = ({ open, onClose }: IConfirmLogoutModal) => {
  const { logoutUser, trackAnalytics } = useMytaverse();

  const handleExitButtonClick = useCallback(async () => {
    sendCustomSentryBreadcrumb({
      message: 'log out in event configuration page',
    });
    await trackAnalytics(AnalyticsType.LogoutClick);
    logoutUser();
    onClose();
  }, [trackAnalytics, logoutUser]);

  return (
    <ConfirmLogoutModalView
      open={open}
      onClose={onClose}
      onExitButtonClick={handleExitButtonClick}
    />
  );
};

export default ConfirmLogoutModal;
